//Style
import '../../styles/cv/card.scss'

//Basic
import React from 'react'
import Project from '../main/project'

//Components 
import Competences from './statscard_competences'
import Language from './statscard_langues'

// Language
import { useLanguage } from '../../context/language_context'


function StatsCard({
    selectedExperience,
    onExperienceClick,
    selectedButton,
    handleWorkButtonClick,
    handleEducationButtonClick,
    handleSkillsButtonClick
}) {

    const { language } = useLanguage()

    let content

    if (selectedExperience === 'compétences') {
        content = <Competences />
    } else if (selectedExperience === 'languages') {
        content = <Language />
    }


    return (

        <section className="cv_card">


            {/* TITLE */}

            <h3>
                {language === 'fr'
                    ? 'Compétences'
                    : 'Skills'}
            </h3>


            {/* WINDOWS MENU */}

            <nav>
                <ul>
                    <li>File</li>
                    <li>Edit</li>
                    <li>View</li>
                    <li>Help</li>
                </ul>
            </nav>


            {/* CATEGORY BUTTONS */}

            <ul className='cv_buttons'>

                <li
                    className={`cv_button work_button ${selectedButton === 'work' ? 'selected' : ''}`}
                    onClick={handleWorkButtonClick}
                >
                    {language === 'fr'
                        ? 'expériences pro'
                        : 'work experience'}
                </li>


                <li
                    className={`cv_button education_button ${selectedButton === 'education' ? 'selected' : ''}`}
                    onClick={handleEducationButtonClick}
                >
                    {language === 'fr'
                        ? 'formation'
                        : 'education'}
                </li>


                <li
                    className={`cv_button stats_button ${selectedButton === 'stats' ? 'selected' : ''}`}
                    onClick={handleSkillsButtonClick}
                >
                    {language === 'fr'
                        ? 'compétences'
                        : 'skills'}
                </li>

            </ul>


            {/* MAIN */}

            <div className="cv_card_main">


                {/* FILES */}

                <div className="cv_card_files">

                    <Project
                        name={
                            language === 'fr'
                                ? 'Langues et langages de code'
                                : 'Languages and programming'
                        }
                        onOpen={() =>
                            onExperienceClick('languages')
                        }
                        isSelected={
                            selectedExperience === 'languages'
                        }
                    />


                    <Project
                        name={
                            language === 'fr'
                                ? 'Compétences'
                                : 'Skills'
                        }
                        onOpen={() =>
                            onExperienceClick('compétences')
                        }
                        isSelected={
                            selectedExperience === 'compétences'
                        }
                    />

                </div>


                {content}


            </div>


            {/* FOOTER */}

            <p className='cv_card_footer'>

                {language === 'fr'
                    ? 'Une diversité de compétences'
                    : 'A diverse range of skills'}

            </p>

        </section>

    )
}


export default StatsCard